import React, { Fragment } from "react";
import { withStyles, Button, Drawer } from "@material-ui/core";
import SearchBox from "../../../../common/SearchBox";
import DataGrid from '@dataGrid';
import styles from "../../styles";
import GridConfig from "./gridConfig";
import { getDataWithQueryString, postData} from "../../../../../api/componentAPIs";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import UserUpdateForm from "./UserUpdateForm";
import MESSAGES from "../../../../../appMessages";
import UserDeletionDialog from "./UserDeletionDialog";
import DrawerContainerStyles from "../../drawerContainerStyles";
import {withAppConfig} from "../../../../../appConfigContext"
import { USER_ROLES_OPTION } from "./constants";
import Events from "../../../../../utilities/EventEmitter";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
class TerminalAccess extends React.Component {
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig({terminalAccessLabel: this.props.terminalAccessLabel});
        this.state= {
            terminalUserData: null,
            errorMessage: null,
            showUserUpdatePanel: false,
            quickFilterText:"",
            terminalList:[],
            availableRoles: [],
            userInfo: null,
            selectedUser: [],
            userUpdateInProgress: false,
            userUpdateError: ""
        }
        this.drawerContainer = React.createRef();
    }

    componentDidMount(){
       this._isComponentMounted = true;
       this.getTerminalUserDetails();
       this.getTerminalList();
       this.getAvailableRoles();
    }

    componentWillUnmount(){
        this._isComponentMounted = false;
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
        this.gridApi.runCommand = this.runCommand;
    }

    // get List of users with the accessible terminals
    getTerminalUserDetails = () => {
        getDataWithQueryString("GetAllUsers").then(
            response =>{
                if(this._isComponentMounted){
                    if(response && response.status >= 200 && response.status < 400){
                        this.setState({
                            terminalUserData: response.data,
                            errorMessage: null
                        });
                    }else{
                        let errorMessage = MESSAGES.COMMON.GRID_DATA_FETCH_FAILED;
                        
                        if(response && response.response && response.response.data && response.response.data.error && response.response.data.error.message ){
                            errorMessage = response.response.data.error.message ;
                        }
                        this.setState({
                            terminalUserData: [],
                            errorMessage
                        });
                        this.props.enqueueSnackbar(
                          MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE.replace(
                            "terminal access",
                            this.props.configJSON.terminalAccessLabel.menuLabel.toLowerCase()
                          ),
                          { variant: "error" }
                        );
                    }
                }
            }
        , error => {
            if(this._isComponentMounted){
                this.setState({
                    terminalUserData: [],
                    errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED
                });
                this.props.enqueueSnackbar(MESSAGES.TERMINAL_ACCESS.FETCH_DATA_FAILURE.replace(
                            "terminal access",
                            this.props.configJSON.terminalAccessLabel.menuLabel.toLowerCase()
                          ), {variant: "error"});
            }
        });
    }

    // Gets the terminals available
    getTerminalList = () => {
        getDataWithQueryString("GetAllTerminals").then(
            response =>{
                if(this._isComponentMounted){
                    if(response && response.status >= 200 && response.status < 400){
                        this.setState({
                            terminalList: response.data.map(terminal => ({
                                value: terminal.terminalId,
                                label: terminal.terminalCode
                            }))
                        });
                    }else{
                        this.setState({
                            terminalList: []
                        });
                        this.props.enqueueSnackbar(`Error fetching terminal list`, {variant: "error"});
                    }
                }
            }
        , error => {
            if(this._isComponentMounted){
                this.setState({
                    terminalList: []
                });
                this.props.enqueueSnackbar(`Error fetching terminal list`, {variant: "error"});
            }
        });
    }

    getAvailableRoles = () => {
        if(this._isComponentMounted){
            this.setState({
              availableRoles: USER_ROLES_OPTION
            });
        }
    }

    refreshUserProfileData = (updatedUserData) => {
        if (this.props.userData.userProfile.userId?.toLowerCase() === updatedUserData.userId?.toLowerCase()) { //refresh userProfile context if user updating his own info
            const terminalIdToRefresh = this.getTerminalToBeRefreshed(updatedUserData);
            Events.emit("RefreshUserInfo", terminalIdToRefresh, null, false);
        }
    }

    /*
     Check if the current active terminal is in the list of other terminals or matches the default terminal. 
     If the current active terminal is available, return its ID; otherwise, return the default terminal's ID.
    */
     getTerminalToBeRefreshed = (updatedUserData) => {
        const { terminal: currentActiveTerminal } = this.props.userData.userProfile;
        const { otherTerminals, defaultTerminal } = updatedUserData;
        const otherTerminalsArray = otherTerminals?.split(',');
        const isCurrentTerminalAvailable = otherTerminalsArray?.includes(currentActiveTerminal.code) || currentActiveTerminal.code === defaultTerminal;

        // Return the current active terminal's ID if available, otherwise return the default terminal's ID
        if (isCurrentTerminalAvailable) {
            return currentActiveTerminal.id;
        }
        return this.state.terminalList.find(terminal => terminal.label === defaultTerminal)?.value;
    }

    createOrUpdateUser = (userData) => {
        const { configJSON } = this.props;
        const {isPasswordUserCreationFlow} =  configJSON;
        const isNewUser = !Boolean(userData.userId);
        
        const requestParams = isNewUser ? isPasswordUserCreationFlow ? {
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            defaultTerminal: userData.defaultTerminal,
            otherTerminals: userData.otherTerminals
                ? userData.otherTerminals.split(",")
                : null,
            roles: this.getRoles(userData.roles)
        } : {
            email: userData.email,
            defaultTerminal: userData.defaultTerminal,
            otherTerminals: userData.otherTerminals
                ? userData.otherTerminals.split(",")
                : null,
            roles: this.getRoles(userData.roles)
        } : {
            userId: userData.userId,
            defaultTerminal: userData.defaultTerminal,
            otherTerminals: userData.otherTerminals
                ? userData.otherTerminals.split(",")
                : null,
            roles: this.getRoles(userData.roles)
        };
        this.setState({
            selectedUser:[userData.email],
            userUpdateInProgress: true
        });
        const user = userData.userName || userData.email;
        postData(isNewUser ? isPasswordUserCreationFlow ? "CreateUserPasswordFlow" : "CreateUserEmailFlow" : "UpdateUser", requestParams).then(response => {
            if(Math.trunc(response.status/100) === 2){
                if(isNewUser){
                    this.props.enqueueSnackbar(`Created user account for ${user}`, {variant: "success"});
                } else {
                    this.refreshUserProfileData(userData);
                    this.props.enqueueSnackbar(`Updated user ${user}`, {variant: "success"});
                }
                this.setState({
                    userUpdateInProgress: false,
                    userUpdateError: ""
                });
                this.closeAddUserPanel();
                this.getTerminalUserDetails();
                return;
            }
            const errorMessage  =  response?.response?.data?.error?.message || 'Create/Update user error';
            this.handleUpdateUserError({user, isNewUser, errorMessage, statusCode: response.status});
        }, () => {
            this.handleUpdateUserError({user, isNewUser, errorMessage: "Something went wrong"});
        });
    }

    handleUpdateUserError = ({user, isNewUser, errorMessage, statusCode}) => {
        this.setState({
            userUpdateInProgress: false,
            userUpdateError: errorMessage,
        });
        if (statusCode === 403) {
            return;
        } else if(isNewUser){
            this.props.enqueueSnackbar(`Error creating user account for ${user}`, {variant: "error"});
            return;
        }
        this.props.enqueueSnackbar(`Error updating user ${user}`, {variant: "error"});
    }

    toggleLock = (userData) => {
        const requestParams = {
            userId: userData.userId
        };
        this.setState({
            selectedUser:[userData.email]
        });
        
        postData("ToggleUserLock", requestParams).then(response => {
            if(Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`User ${userData.userName} is ${userData.isLocked ? "locked" : "unlocked"}`, {variant: "success"});
                this.getTerminalUserDetails();
                return;
            }
            this.handleToggleUserLockError(userData, response.status);
        }, () => {
            this.handleToggleUserLockError(userData);
        });
    }

    handleToggleUserLockError = (userData, statusCode) => {
        if (statusCode === 403) {
            return;
        }
        this.props.enqueueSnackbar(`Error ${userData.isLocked ? "locking" : "unlocking"} user ${userData.userName}`, {variant: "error"});
    }
    

    getSelectedUserData = (userData) => {
        this.setState({
            selectedUserData: userData
        });
    }

    onCancelUserDeletion = () =>{
        this.setState({
            selectedUserData: null
        });
    }

     // Deleting user from the table
     deleteUser = (userData, props) => {
        const requestParams = {
            userId: userData.userId
        }
        postData("DeleteUser", requestParams).then(response => {
            if(response && Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`Deleted user ${userData.userName} `, {variant: "success"});
                this.getTerminalUserDetails();
                return;
            }
            this.handleDeleteUserError(userData, response.status);
        }, () => {
            this.handleDeleteUserError(userData);
        });
    }

    handleDeleteUserError = (userData, statusCode) => {
        if (statusCode === 403) {
            return;
        }
        this.props.enqueueSnackbar(`Error deleted user ${userData.userName} `, {variant: "error"});
    }

    selectedUser = () => {
        if(this.state.selectedUser.length && this.gridApi){
            this.gridApi.forEachNode(node => {
                if(this.state.selectedUser.includes(node.data.email)){
                    this.gridApi.ensureIndexVisible(node.rowIndex);
                    node.setSelected(true);
                 }
            });
           
        }
    }

    getRoles = (roles) => {
        if(!roles) {
            return null;
        }
        
        const rolesArray = roles.split(",");
        return rolesArray;
    }

    // Calls different operations to be done on selected user
    runCommand = (command, data) => {
        const userData = {...data};
        let userState = "";
        switch (command) {
            // case "lockUser"  : userData.isLocked = true;
            //                    userState = `Locking User ${userData.userName}`
            //                    this.updateUserLockStatus(userData);
            //                    break;
            // case "unlockUser": userData.isLocked = false;
            //                    userState = `Unlocking User ${userData.userName}`
            //                    this.updateUserLockStatus(userData);
            //                    break;
            case "editUser":   this.editUserInfo(userData);
                               break;
            case "deleteUser":this.getSelectedUserData(userData);
                              break;
            default:
                break;
        }
        // add a snackbar to show the action being executed on the user
        if(userState){
            this.props.enqueueSnackbar(userState, {variant: "info"});
        }
        // Save selection to retain it for data refresh
        this.setState({
            selectedUser:[userData.email]
        });
    }

    // method to override lockStatus of the user
    updateUserLockStatus = (userData) => {
        this.toggleLock(userData);
        this.setState({
            selectedUser:[userData.email]
        });
    }

    // Opens the edit user panel for updating user information
    editUserInfo = (userData) => {
        this.setState({
            userInfo: userData,
            showUserUpdatePanel: true,
            userUpdateError: null
        });
    }

    //
    openAddUserPanel = () =>{
        this.setState({
            userInfo: null,
            showUserUpdatePanel: true
        });
    }


    closeAddUserPanel = () =>{
        this.setState({
            showUserUpdatePanel: false
        });
    }

    updateQuickFilterText =(quickFilterText) => {
        this.setState({quickFilterText});
    }

    render(){
        const { classes } = this.props;
        return (
          <Fragment>
            <header
              className={`${classes.moduleHeader} ${classes.transition} ${
                this.state.showUserUpdatePanel ? classes.shiftedContent : ""
              }`}
              data-automationid="terminalAccess-title"
            >
              {this.props.terminalAccessLabel.moduleTitle}
            </header>
            <div
              className={`${classes.moduleContainer} ${classes.transition} ${
                this.state.showUserUpdatePanel ? classes.shiftedContent : ""
              }`}
            >
              <div className={classes.moduleMessage}>
                {`Users can get access to plans for different ${this.props.terminalAccessLabel.fullName.toLowerCase()}s here. Note: Default ${this.props.terminalAccessLabel.fullName.toLowerCase()} plan will open automatically when user logs in.`}
              </div>
              <div
                className={`${classes.gridContainer} ${classes.terminalGridContainer}`}
                ref={this.drawerContainer}
              >
                <div className={classes.gridHead}>
                  <span className={classes.gridActionIcons}>
                    <SearchBox
                      onChange={this.updateQuickFilterText}
                      customSearchClass={classes.customSearchClass}
                    />
                    <ClearAllFilterButton gridApi={this.gridApi} />
                  </span>
                </div>
                <div>
                    <div className={`${classes.dataGrid} ${classes.terminalGrid}`}>
                    {!this.state.errorMessage ? (
                        <DataGrid
                        defaultColDef={this.gridConfig.config.defaultColDef}
                        columnDefs={this.gridConfig.config.columns}
                        config={this.gridConfig.config}
                        rowSelection={this.gridConfig.config.rowSelection}
                        rowData={this.state.terminalUserData}
                        onGridReady={this.onGridReady}
                        onCellValueChanged={this.onCellValueChanged}
                        quickFilterText={this.state.quickFilterText}
                        onRowDataUpdated={this.selectedUser}
                        getRowId={(params) => params.data.userId}
                        />
                    ) : (
                        <div className={classes.errorMessageContainer}>
                        <div className={classes.errorMessage}>
                            {this.state.errorMessage}
                        </div>
                        </div>
                    )}
                    </div>
                    <div className={classes.actionContainer}>
                    <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        classes={{ root: classes.actionButton }}
                        onClick={this.openAddUserPanel}
                        data-automationid="createNewUser"
                    >
                        Create new user
                    </Button>
                    </div>
                </div>
              </div>
              {this.state.showUserUpdatePanel && (
                <Drawer
                  ModalProps={
                    this.drawerContainer.current
                      ? { container: this.drawerContainer.current }
                      : {}
                  }
                  variant="persistent"
                  anchor="right"
                  open={this.state.showUserUpdatePanel}
                  classes={{
                    paper: `${classes.paperAnchor} customScroll ${
                      !this.state.showUserUpdatePanel ? classes.paperHidden : ""
                    }`,
                    modal: classes.modal,
                  }}
                  BackdropProps={{
                    className: classes.backdrop,
                  }}
                >
                  <UserUpdateForm
                    terminalList={this.state.terminalList}
                    availableRoles={this.state.availableRoles}
                    userInfo={this.state.userInfo}
                    onClose={this.closeAddUserPanel}
                    onCreateOrUpdateUser={this.createOrUpdateUser}
                    userUpdateInProgress={this.state.userUpdateInProgress}
                    error={this.state.userUpdateError}
                    isPasswordUserCreationFlow={
                      this.props.configJSON.isPasswordUserCreationFlow
                    }
                    terminalAccessLabel={
                      this.props.configJSON.terminalAccessLabel
                    }
                  />
                </Drawer>
              )}
            </div>
            {this.state.selectedUserData && (
              <UserDeletionDialog
                userData={this.state.selectedUserData}
                onConfirm={this.deleteUser}
                onCancel={this.onCancelUserDeletion}
              />
            )}
          </Fragment>
        );
    }
}

export default compose(withStyles((theme) => ({
    ...styles(theme),
    ...DrawerContainerStyles(theme),
})),withUserProfile, withSnackbar,withAppConfig)(TerminalAccess)